module.exports = __webpack_public_path__ + "img/information-and-communication-technology.62be6b52.svg";